import MembAccnDtlInfoInqApi from "Apis/MembAccnDtlInfoInqApi";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "Assets/css/StarRate.css";
import StarRateApi from "Apis/StarRateApi";
import { validateInput } from 'Utils/XssFilter';
import ApiResultModal from "Components/ApiResultModal";

const StarRateUi = ({langData,gameSvcCd,qnaSno,onStarRateComplete}:any) => {
    const [score, setScore] = useState<number>(0);
    const [scoreFixed, setScoreFixed] = useState(score);
    const [feedbackState,setFeedbackState] = useState("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };
    
    // 1단위로 변경 - 별 전체 클릭 시 해당 점수로 설정
    const handleStarEnter = (idx: number) => setScore(idx + 1);
    const handleStarClick = () => {
        setScoreFixed(score);
    };
    const handleStarLeave = () => {
        if (score !== scoreFixed) {
        setScore(scoreFixed);
        }
    };
    const FeedbackHandler = (e:any) => {
        // XSS 필터링 적용 - 불순한 태그 제거
        const filteredValue = validateInput(e.currentTarget.value, 'basic', true);
        setFeedbackState(filteredValue);
    }
    const StarRateFunc = () => {
        // 빈 피드백 체크
        if (!feedbackState.trim()) {
            openResultModal("피드백을 입력해주세요.");
            return;
        }
        
        // 확인창 표시
        const confirmMessage = "피드백 작성후 변경 불가능합니다. 작성하시겠습니까?";
        if (!window.confirm(confirmMessage)) {
            return; // 사용자가 취소를 누르면 함수 종료
        }
        
        // 최종 전송 전 한 번 더 XSS 필터링
        const safeFeedback = validateInput(feedbackState, 'basic', true);
        
        StarRateApi(gameSvcCd,qnaSno,score,safeFeedback)
        .then((resp) => {
            // API 호출 성공 시 콜백 호출
            if(onStarRateComplete && resp.apiHdr.code === "MEMB0000") {
                onStarRateComplete();
            }
        })
        .catch((error) => {
            console.error("StarRateApi 에러:", error);
        });
    }
    return(
        <>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <div className="qnaTitlWrap">
                <p>{langData&&langData.CS_QNA_STAR_RTNG_DESC_00}</p>
                <div className="starRateWrap">
                    {Array(5).fill(0).map((i,idx)=>(
                        <div className="starDiv" 
                            key={idx}  
                            onClick={handleStarClick}
                            onMouseEnter={() => handleStarEnter(idx)}
                            onMouseLeave={handleStarLeave}
                            style={{ position: "relative", cursor: "pointer" }}
                        >
                            {idx + 1 > score ? (
                            <div className="star starDisable"
                                key={idx}
                                style={{ position: "absolute" }}
                            />
                            ) : (
                            <div className="star starActive"
                                key={idx}
                                style={{ position: "absolute" }}
                            />
                            )}
                        </div>
                    ))}
                </div>
                <textarea name="" id="feedbackTextArea"  onChange={FeedbackHandler} >
                </textarea>
            </div>
            <div className="ctntBtnWrap qnaCtntBtnWrap dFlex">
                <Link to={`/MyPage/QnaLst`}>
                    <p>{langData&&langData.GLB__COMM_LST_BTN_00}</p>
                </Link>
                <button onClick={StarRateFunc}>
                    <p>댓글작성</p>
                </button> 
            </div>
        </>
    )
}

export default StarRateUi;